// extracted by mini-css-extract-plugin
export default {"text-divider":"FvdRea","textDivider":"FvdRea","text-divider-line":"TGkrR6","textDividerLine":"TGkrR6"};